export default __webpack_public_path__ + "static/media/mahabalipuram.af57f826.jpg";